const Footer = () => {
    return (
        <footer id="footer" className="py-2 bg-dark mt-auto">
            <div className="container">
                <p className="m-0 text-center text-white">&copy; Kutije i cveće LETUS. Copyright by
                    <a className="text-decoration-none" target="_blank" rel="noreferrer" href="https://www.instagram.com/vladadime/"> Vladan Dimitrijević</a>
                </p>
            </div>
        </footer>
    )
}

export default Footer
